import { render, staticRenderFns } from "./Deposite.vue?vue&type=template&id=3b8a97cf&scoped=true"
import script from "./Deposite.vue?vue&type=script&lang=js"
export * from "./Deposite.vue?vue&type=script&lang=js"
import style0 from "./Deposite.vue?vue&type=style&index=0&id=3b8a97cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8a97cf",
  null
  
)

export default component.exports